<template>
  <div class="behaviorTagretList">
    <div class="filters">
      <el-form :inline="true">
        <!-- 物业人员 -->
        <el-form-item label="" prop="staffId">
          <el-select class="item-input" v-model="staffId" placeholder="请选择物业人员" @change="changeStaff" filterable>
            <el-option key label="请选择物业人员" value=""></el-option>
            <el-option v-for="item in staffList" :key="item.id" :value="item.id" :label="item.idNo">
            </el-option>
          </el-select>
        </el-form-item>
        <el-button type="primary" @click="getData">{{$t('lang.btn_search')}}</el-button>
      </el-form>
    </div>
    <el-card>
      <el-button type="primary" slot="header" @click="add">{{$t('lang.btn_wj_addNews')}}</el-button>
      <el-table :data="tableData"
        :height="tableData.length > 0 ? require('@/config/enum').tableheight529 : require('@/config/enum').tableheight109"
        class="wid100" :row-class-name="tableRowClassName" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55" v-if="proprietorNotificationListbox"></el-table-column>
        <el-table-column type="index" :index="indexMethod" align="center" :label="$t('lang.lab_index')" width="100px">
        </el-table-column>
        <el-table-column prop="staffName" label="物业人员">
        </el-table-column>
        <el-table-column prop="remark" label="情节描述">
          <template slot-scope="scope">
            <el-tooltip placement="top" effect="light"
              v-if="scope.row.remark&&scope.row.remark.length> require('@/config/enum').tableDatamaxlength50"
              :disabled="false">
              <div slot="content" style="width: 400px;">
                <span>
                  {{ scope.row.remark }}
                </span>
              </div>
              <div>
                {{ scope.row.remark.substring(0, require('@/config/enum').tableDatamaxlength50) | valueIsNull }}
                <span v-if="scope.row.remark.length>require('@/config/enum').tableDatamaxlength50">...</span>
              </div>
            </el-tooltip>
            <el-tooltip placement="top" effect="light" v-else :disabled="true">
              <div>{{ scope.row.remark | valueIsNull }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="point" label="分数">
        </el-table-column>
        <el-table-column prop="fjList" label="上传图片">
          <template slot-scope="scope">
            <viewer :images="scope.row.fjList" class="img-width" v-if="scope.row.fj">
              <img v-for="(src,index) in scope.row.fjList" :src="src" :key="index" class="img">
            </viewer>
          </template>
        </el-table-column>
        <el-table-column prop="operation" :label="$t('lang.lab_operation')"
          :width="require('@/config/enum').opr_width2">
          <template slot-scope="scope">
            <el-button @click="edit(scope.row)">{{$t('lang.btn_modify')}}</el-button>
            <el-button class="orange" @click="deleteOne(scope.row.id)">{{$t('lang.btn_delete')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNo"
        :page-sizes="[10, 20, 30, 50]" :page-size="pageSize" layout="sizes, prev, pager, next, jumper"
        :page-count="pageCount" />
    </el-card>
  </div>
</template>

<script>
  /**
   *@ClassName:behaviorTagretList
   *@Description:行为指标管理
   *@author:杜斌
   *@Copyright:格众科技
   *@date:2020-02-19
   */
  // import { mapGetters } from 'vuex'
  export default {
    name: '/manage/main.behaviorTagretList',
    data() {
      return {
        multipleSelection: [], // 多选框
        gardenId: this.$store.getters.gardenId, // 小区绑定值
        staffId: '',
        staffList: [],
        tableData: [], // 新闻list
        pageNo: 1, // 页数
        pageSize: 10, // 每页显示数量
        pageCount: 0, // 总页数
        proprietorNotificationListbox: require('@/config/enum').proprietorNotificationListbox // 是否隐藏复选框
      }
    },
    created() {
      setTimeout(() => {
        window.localStorage.setItem('behaviorTagretform', '')
      }, 200)
      this.getData()
      this.getStaffList()
    },
    activated() {
      this.getData()
      this.getStaffList()
    },
    methods: {
      // 获取物业人员列表
      getStaffList() {
        let loading = this.$loading()
        this.$get(
          `/staffs?pageSize=9999&pageNo=1&gardenId=${this.$store.getters.gardenId}`
        ).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              console.log(res)
              this.staffList = res.list
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // 修改物业人员
      changeStaff(value) {
        this.staffId = value
      },
      // 获取列表数据
      getData() {
        let loading = this.$loading()
        this.$get(`/senceAction?staffId=${this.staffId}&gardenId=${this.gardenId}&pageNo=${this.pageNo}&pageSize=${this.pageSize}`).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              console.log(res)
              this.tableData = res.list
              this.pageCount = res.pageCount
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          })
      },
      // 新增
      add() {
        // setTimeout(() => {
        window.localStorage.setItem('behaviorTagretform', '')
        // }, 200)
        this.$router.push({
          name: 'behaviorTagretAdd',
          query: {
            flag: false
          }
        })
      },
      // 编辑
      edit(row) {
        console.log(row)
        // setTimeout(() => {
        window.localStorage.setItem('behaviorTagretform', '')
        // }, 200)
        this.$router.push({
          name: 'behaviorTagretAdd',
          query: {
            flag: true,
            object: row
          }
        })
      },
      // 删除
      deleteOne(id) {
        let loading = this.$loading()
        this.$confirm(this.$i18n.t('lang.lab_isdelete'), this.$i18n.t('lang.lab_prompt'), {
            confirmButtonText: this.$i18n.t('lang.btn_confirm'),
            cancelButtonText: this.$i18n.t('lang.btn_cancel'),
            type: 'warning'
          }).then(() => {
            this.$delete(`/senceAction/` + id).then(
              res => {
                loading.close()
                if (res && res.errCode === 0) {
                  this.$message({
                    type: 'success',
                    message: this.$i18n.t('lang.lab_del_success')
                  })
                  this.commit()
                }
              },
              error => {
                loading.close()
                this.$message.error(error)
              }
            )
          })
          .catch(() => {
            loading.close()
            this.$message({
              type: 'info',
              message: this.$i18n.t('lang.lab_del_can')
            })
          })
      },
      // 更新
      commit() {
        this.pageNo = 1
        this.getData()
      },
      // 翻页
      handleCurrentChange(val) {
        this.pageNo = val
        this.getData()
      },
      // 切换每页显示多少数据
      handleSizeChange(val) {
        this.pageNo = 1
        this.pageSize = val
        this.getData()
      },
      // 表格斑马
      tableRowClassName({
        row,
        rowIndex
      }) {
        return rowIndex % 2 === 0 ? 'row-dark' : ''
      },
      // 多选框
      handleSelectionChange(val) {
        this.multipleSelection = val
      },
      // ID序号功能
      indexMethod(index) {
        return (this.pageNo - 1) * this.pageSize + index + 1
      },
    },
    mounted() {

    },
  }
</script>

<style>
  .behaviorTagretList {
    .img {
      width: 80px;
      height: 50px;
      border: 1px solid lightgray;
      border-radius: 5px;
      padding: 5px;
    }

    .img-width {
      overflow: hidden !important;
      text-overflow: ellipsis !important;
      white-space: nowrap !important;
      max-width: 320px;
    }
  }
</style>